import React from "react";
import { Card, Box } from "@bca/ui-library";

import Skeleton from "../Skeleton";

const ProxyBidSkeleton: React.FunctionComponent<{}> = () => {
  return (
    <Card
      width="100%"
      height="201px"
      marginX={0}
      marginY={0}
      data-testid="proxy-bid-skeleton"
    >
      <Skeleton variant="text" width={80} height={20} mb={12} />
      <Skeleton variant="text" width="100%" height={14} mb={1} />
      <Skeleton variant="text" width={150} height={14} mb={12} />
      <Skeleton variant="text" width={106} height={16} mb={12} />
      <Box display="flex">
        <Skeleton variant="text" width={196} height={40} mr={18} />
        <Skeleton variant="text" width={160} height={40} animationDelay={0.4} />
      </Box>
    </Card>
  );
};

export default ProxyBidSkeleton;
